const React = require('react');
const delay = require('mn-utils/delay');
const map = require('mn-utils/map');
const handleProviderProvider = require('mn-utils/changeProviderProviderSimple');
const withState = require('../../../../../utils/withState');
const {
  apiV2KycDocumentsSubmit,
} = require('../../../../../api/merchant/kyc');
const {
  apiV2KycDocumentUpload,
  apiV2KycDocumentRemove,
} = require('../../../../../api/merchant/kyc');
const InputUpload = require('../../../../dumb/Upload/C');
const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading/B');
const ButtonSave = require('./Button/Save');
const ButtonNext = require('./Button/Next');


module.exports = withState((setState, self, onMount) => {
  const handleProvider = handleProviderProvider(setState);
  const handleChangeOtherDocs = handleProvider('otherDocs');
  const handleChangeLoadingOtherDocs = handleProvider('loadingOtherDocs');

  let _defaultState;

  function update() {
    delay(() => {
      setState({
        otherDocs: map(_defaultState && _defaultState.list, (v) => {
          return {
            fileId: v.id,
            name: v.file_name || v.id,
          };
        }, []),
      });
    });
  }
  function submit() {
    setState({
      loading: true,
    });
    return apiV2KycDocumentsSubmit().finally(() => {
      setState({
        loading: false,
      });
    });
  }
  function handleSubmit() {
    submit().then(self.props.onSubmit);
  }
  function handleNext() {
    submit().then(self.props.handleSubmitAndNext);
  }

  onMount(() => {
    self.props.onMount();
  });

  return (state, props) => {
    const disabled = state.loadingOtherDocs;
    const defaultState = props.defaultState;

    _defaultState === defaultState || update(_defaultState = defaultState);


    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <div className="f23 fw3 lh34 lts0em c0">
          Do you feel any other document will help us speed up the
          onboarding process? Please upload using the link below.
        </div>
        <div className="mt30 f12 fw3 lh18 lts0em c828282">
          Accepted types - PDF, scanned copy, clear photo JPEG, JPG, PNG and not
          more than 25 MB for each document.
        </div>
        <InputUpload
          className="mt40 cfx mh-10 (lt|w1/3|w1/2@m2|w@m3|ph10|mb20)>1"
          label="Upload file"
          value={state.otherDocs || []}
          type="other"
          multiple
          limit={20}
          buttonAtTheStart
          onChange={handleChangeOtherDocs}
          onLoading={handleChangeLoadingOtherDocs}
          openConfirm={props.handleOpenConfirm}
          openConfirmRemove={props.handleOpenConfirmRemove}
          apiUpload={apiV2KycDocumentUpload}
          apiRemove={apiV2KycDocumentRemove}
        />
        <div className="layoutRow fvaC fhaB mt34">
          <ButtonSave
            disabled={disabled}
            onClick={handleSubmit}
          />
          <ButtonNext
            disabled={disabled}
            onClick={handleNext}
          />
        </div>
      </WrapperWithLoading>
    );
  };
}, {});
